export const Feedbacks = [
    {
      label: '“Digift stood out from the crowd with an impressive team and even more impressive mission: harnessing the power of giftcards enterprises to support people who are restricted by banks in Nigeria.”',
      Name: "Osemwengie Benjamin",
      title: 'Product Designer at Digift',
    },
    {
      label: '“Digift stood out from the crowd with an impressive team and even more impressive mission: harnessing the power of giftcards enterprises to support people who are restricted by banks in Nigeria.”',
      Name: "Osemwengie Benjamin",
      title: 'Product Designer at Digift',
    },
    {
      label: '“Digift stood out from the crowd with an impressive team and even more impressive mission: harnessing the power of giftcards enterprises to support people who are restricted by banks in Nigeria.”',
      Name: "Osemwengie Benjamin",
      title: 'Product Designer at Digift',
    },
  ];